import { Link as RouterLink } from 'react-router-dom';

import { MoonIcon, SunIcon } from '@chakra-ui/icons';
import {
    Box, Button, Flex, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, useColorMode,
    useColorModeValue,
} from '@chakra-ui/react';

import { useAuth } from '../contexts/AuthContext';

export default function Navigation() {
  const { user, signOut } = useAuth();
  const { colorMode, toggleColorMode } = useColorMode();
  const bg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Box
      bg={bg}
      px={4}
      borderBottom="1px"
      borderColor={borderColor}
      position="sticky"
      top={0}
      zIndex={1}
    >
      <Flex h={16} alignItems="center" justifyContent="space-between">
        <HStack spacing={8} alignItems="center">
          <RouterLink to="/">
            <Box fontWeight="bold" fontSize="lg">
              Fraudo
            </Box>
          </RouterLink>
        </HStack>

        <Flex alignItems="center">
          <IconButton
            aria-label="Toggle color mode"
            icon={colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            onClick={toggleColorMode}
            variant="ghost"
            mr={4}
          />

          {user ? (
            <Menu>
              <MenuButton as={Button} variant="ghost">
                {user.email}
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => signOut()}>Sign Out</MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <HStack spacing={4}>
              <RouterLink to="/login">
                <Button variant="ghost">Sign In</Button>
              </RouterLink>
              <RouterLink to="/register">
                <Button colorScheme="blue">Sign Up</Button>
              </RouterLink>
            </HStack>
          )}
        </Flex>
      </Flex>
    </Box>
  );
}
